<div class="content">
  <div class="content-close" (click)="onNoClick()">
    <img src="../../../assets/img/icons/close-white-bg.png">
  </div>
  <div class="content-container">
    <h3 class="content-container__title">{{data.title}}</h3>

    @if (showErrorPopup) {
      <div class="content-container__body">
        <p>Sorry, we were unable to send your referral. Please try again.</p>
        <div class="trybtnSec">
          <div class="content-container__btn">
            <button class="content-container__btn--cancel" (click)="onNoClick()">Cancel</button>
          </div>
          <div class="content-container__btn">
            <button class="content-container__btn--save" (click)="tryagain()">Try again</button>
          </div>
        </div>
      </div>
    }

    @if (!showErrorPopup) {
      <div class="content-container__body">
        <form [formGroup]="newhistoryForm" (ngSubmit)="Submitcode()">
          <div class="content-container__questions">
            @for (questionset of referDetails.referQuestions; track questionset) {
              <div>
                <div class="content-container__questions-{{questionset.classId}}">
                  @for (question of questionset.questions; track question) {
                    <div class="content-container__questions-{{questionset.classId}}--item"
                      >
                      @if (question.type === 'select') {
                        <div [cbSelectChoice]="cisaSelectRef"
                          [label]="question.label"
                          [hideRequiredMarker]="true"
                          styleVariant="gray-fill">
                          <p-select #cisaSelectRef
                            [formControl]="formControlObj[question.code]"
                            [options]="question.list_of_options"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select..."
                            [inputId]="question.code"
                            (onChange)="setValues($event.value, question.code)">
                          </p-select>
                        </div>
                      }
                      @if (question.type === 'text') {
                        <div cbInput
                          [label]="question.label"
                          hideRequiredMarker="true"
                          [errorState]="newhistoryForm.get(question.code)?.invalid && newhistoryForm.get(question.code)?.touched"
                          [class.has-error]="newhistoryForm.get(question.code)?.invalid && newhistoryForm.get(question.code)?.touched">
                          <input type="text" name="question.code" (keyup)="handleStore()" (keydown)="countMax($event)"
                            [formControl]="formControlObj[question.code]" required="true" />
                          </div>
                        }
                        @if (question.type === 'text') {
                          <p class="maxchars">Max characters allowed {{maxchar}}</p>
                        }
                        @if (question.type === 'number') {
                          <div cbInput
                            [label]="question.label"
                            hideRequiredMarker="true"
                            [errorState]="newhistoryForm.get(question.code)?.invalid && newhistoryForm.get(question.code)?.touched"
                            [class.has-error]="newhistoryForm.get(question.code)?.invalid && newhistoryForm.get(question.code)?.touched">
                            <input type="tel" placeholder="Phone number" name="question.code"
                              (keyup)="handleStore()" [formControl]="formControlObj[question.code]"
                              required="true" mask="(000) 000-0000" />
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
              @for (item of referDetails.navButtons; track item) {
                <div class="content-container__btn">
                  <button type="button" class="content-container__btn--{{item.btnClass}}"
                    [disabled]="((item.btnClass === 'save') ? disabledNavigation : false)"
                    (click)="((item.btnClass === 'cancel') ? onNoClick() : true)">{{item.btnText}}
                  </button>
                </div>
              }
            </form>
          </div>
        }

      </div>
    </div>
